/* eslint-disable no-undef */

const useDownloadFile = () => {
  const download = (fileName, url, openNewTab = true) => {
    const element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('download', fileName);
    if (openNewTab) {
      element.setAttribute('target', '_blank');
      element.setAttribute('rel', 'noopener');
    }

    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return [download];
};

export default useDownloadFile;
